import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface WrapperProps {
  $noMargin?: boolean;
}

export const Wrapper = styled.div.withConfig({ componentId: 'sc-1jx2p1k-0' })<WrapperProps>`
    margin-top: ${size(0.5)};
    font-size: 0.75rem;
    color: var(--c-text-muted);

    ${({ $noMargin }) =>
      $noMargin &&
      css`
            margin-top: 0;
        `}
`;
